import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { useSiteContent } from "./siteContent";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DishOfDay({ onReservar }) {
  const [dish, setDish] = useState(null);
  const site = useSiteContent();

  useEffect(() => {
    axios
      .get(`${API}/dish-of-day`)
      .then((r) => setDish(r.data))
      .catch(() => {});
  }, []);

  if (!dish || !dish.name || dish.active === false) return null;

  return (
    <section
      data-testid="dish-of-day-section"
      className="bg-[#102C1F] text-[#F4F1EB]"
    >
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 py-20 md:grid-cols-[1.4fr_1fr] md:px-10 md:py-28">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p
            data-testid="dish-of-day-label"
            className="-mt-4 mb-4 text-sm uppercase tracking-[0.25em] text-[#F4F1EB]/60 md:-mt-8 md:text-base"
          >
            {site.dishofday_label}
          </p>
          <h2
            data-testid="dish-of-day-name"
            className="font-display text-4xl italic tracking-tight sm:text-5xl"
          >
            {dish.name}
          </h2>
          {dish.description && (
            <p
              data-testid="dish-of-day-desc"
              className="mt-4 max-w-md text-sm text-[#F4F1EB]/80 md:text-base"
            >
              {dish.description}
            </p>
          )}
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col items-start gap-6 md:items-end"
        >
          {dish.image && (
            <img
              data-testid="dish-of-day-image"
              src={dish.image}
              alt={dish.name}
              loading="lazy"
              className="aspect-[4/3] w-full max-w-sm rounded-sm object-cover"
            />
          )}
          <span
            data-testid="dish-of-day-price"
            className="font-display text-4xl italic md:text-5xl"
          >
            €{Number(dish.price).toFixed(2)}
          </span>
          <button
            data-testid="dish-of-day-reserve-btn"
            onClick={onReservar}
            className="rounded-full bg-[#F4F1EB] px-7 py-3 text-xs uppercase tracking-[0.2em] text-[#102C1F] transition-colors duration-300 hover:bg-[#E5DFD3]"
          >
            {site.dishofday_btn}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
